// src/utils/authStorage.js
//
// Sessions are bounded to a (role, email) pair, not just "whoever's logged
// in": each role gets its own localStorage slot so a winery-owner login and
// a traveler login can coexist in the same browser without one shadowing
// the other (this used to be a single shared "wr_token" key — logging into
// either portal clobbered/re-used the other's session, which is why
// visiting the traveler-facing Account page could show a Winery Owner
// profile). The JWT itself already carries a fixed identity (its sub/email
// claims belong to one specific account), so scoping storage by role is
// sufficient to keep sessions independent — no need to also key by email.
export const LEGACY_TOKEN_KEY = "wr_token";
export const tokenKey = (role) => `wr_token_${role}`;
export const getStoredToken = (role) => localStorage.getItem(tokenKey(role));
export const setStoredToken = (role, token) => localStorage.setItem(tokenKey(role), token);
export const clearStoredToken = (role) => localStorage.removeItem(tokenKey(role));
